import { HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { BaseService } from 'src/app/core/services/base.service';
import { FavoritoModel } from 'src/app/main/hao/models/favorito.model';
import { HaoModel } from 'src/app/main/hao/models/hao.model';
import { HeadhunterModel } from 'src/app/main/headhunter/models/headhunter.model';

@Injectable({
  providedIn: 'root'
})
export class FavoritoService extends BaseService {
  private baseUrl = '/favorito';

  getAllHao(): Observable<FavoritoModel[]> {
    return this.baseGet(`${this.baseUrl}/getAllHao`);
  }

  getAllPhh(): Observable<FavoritoModel[]> {
    return this.baseGet(`${this.baseUrl}/getAllPhh`);
  }

  add(body: any): Observable<FavoritoModel[]> {
    return this.basePost(`${this.baseUrl}/add/`, body);
  }

  remove(cardId: number): Observable<FavoritoModel[]> {
    const params = new HttpParams().append('cardId', String(cardId));
    return this.baseGetWithParams(`${this.baseUrl}/remove`, params);
  }

  getAllFavorite(): Observable<HaoModel[]> {
    return this.baseGet(`${this.baseUrl}/getFavoriteHao`);
  }

  getFavoriteHeadhunter(): Observable<HeadhunterModel[]> {
    return this.baseGet(`${this.baseUrl}/getFavoriteHh`);
  }

}
